import {history, a11yAnnounce} from 'fn-common-ui';
import moment from 'moment';
import _ from 'lodash';

class UtilsService {
  triggerCustomEvent(name, detail) {
    let event = new window.CustomEvent(name, {detail});
    window.dispatchEvent(event);
  }

  scrollTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    document.getElementById("root-anchor").focus();
  }

  versionNumberNormalizer(versionNumber) {
    if(!versionNumber) return '';
    return versionNumber.includes('.') ? convertToUnderscore() : convertToPeriod();
    function convertToUnderscore() {
      return versionNumber.replace(/\./g, "_");
    }
    function convertToPeriod() {
      return versionNumber.replace(/\_/g, ".");
    }
  }

  generateAppPageURI(appObject, mode) {
    const id =  appObject.applicationId || '';
    const version = this.versionNumberNormalizer(typeof appObject.version === 'object' ? appObject.version.version_num : appObject.version);
    const saveId = appObject.save_id || appObject.saveId || '';
    let uri = '';
    if(mode === 'copy' || (appObject.custom_metadata && appObject.custom_metadata.status === 'DRAFT')){
      uri = `/new-application/app-details/${saveId}`;
    } 
    else {
      uri = `/app/${mode}/${id}/${version}/${saveId}`;
      //mode = view
      //uri = `/new-application/app-details/${saveId}`;
    }
    return uri;
  }

  getFileName(file) {
    const parsedFile = /^(.*)\.\w+$/.exec(file);
    if (parsedFile) return parsedFile[1];
  }

  getFileExtension(file) {
    const parsedFile = /.*\.(\w+)$/.exec(file);
    if (parsedFile) return parsedFile[1];
  }

  extractPayloadProperties(file) {
    return {
      binary: file,
      get name() {
        return /^(.*)\.\w+$/.exec(this.binary.name)[1];
      },
      get extension() {
        return /.*\.(\w+)$/.exec(this.binary.name)[1];
      }
    }
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  normalizedDate(date, displayFormat = 'MMMM D, YYYY') {
    if (!date) {
      //because of errors occurring in QA app approval process, some date fields may be missing. This error message has been requested to assist QA. Theoretically, the prod approval process is more rigorous and this message should never show.
      return 'Missing Date';
    }
    //all dates come from services in Unix (epoch) time, which is in seconds. Use .valueOf() to convert to milliseconds for use in Moment and date-fns;
    const newDate = moment(Number(date))
    //check if the date is in a valid format, else return 'Bad Date Format'. this error message has been requested to assist QA in the app submission process;
    const dateToRender = newDate.isValid() ? newDate.format(displayFormat) : 'Bad Date Format';
    return dateToRender;
  }

  normalizeReleaseDate(releaseDate, optionalString = '') {
    if (typeof releaseDate === 'string' && releaseDate.toLowerCase() === 'immediately') {
      return 'Immediately' + optionalString;
    } else {
      return this.normalizedDate(releaseDate);
    }
  }

  /**
   * Handles basic networking errors for service calls
   * @param  {Error} err Error object received from network call
   */
  handleError(err) {
    switch (err.response.status) {
      case 403:
        console.warn('Received 403 Forbidden response, redirecting to unauth error page...');
        history.replace('/error/unauthorized');
        break;
      case 500:
        console.warn('Received 500 Internal Error response, redirecting to general error page...');
        console.warn(err);
        history.replace('/error');
        break;
      default:
        console.warn('Received ' + err.response.status + ' response, redirecting to general error page...');
        console.warn(err);
        history.replace('/error');
        break;
    }
  }

  renderPlatformName(platform){
    let name = '';
    if(!platform || platform === undefined){
      name= 'Not Available';
      return name;
    }
    if(platform.toLowerCase() === 'android'){
      name = 'Android';
    }
    if(platform.toLowerCase() === 'ios'){
      name = 'iOS';
    }
    return name;
  }

  formatStatus(status) {
    return status = _.startCase(status.toLowerCase())
  }

  announceSuccess(actionWord) {
    a11yAnnounce({
      message: `${actionWord} complete.`,
      messageType: 'status'
    });
  }

  announceFailure(actionWord, errorMessage = '') {
    a11yAnnounce({
      message: `${actionWord} failed. ${errorMessage}`,
      messageType: 'status'
    });
  }
}

export const utilsService = new UtilsService();
